export function DocBlock({ block }) {
  switch (block.type) {
    case "h3":
      return <h3 className="mt-8 text-xl font-bold text-navy">{block.text}</h3>;
    case "p":
      return <p className="mt-4 text-base text-navy/75 leading-relaxed">{block.text}</p>;
    case "callout":
      return (
        <div className="mt-6 rounded-xl bg-terracotta-light border-l-4 border-terracotta p-5">
          <p className="text-sm font-semibold text-navy/80 leading-relaxed">{block.text}</p>
        </div>
      );
    case "list":
      return (
        <ul className="mt-4 space-y-2.5 list-disc pl-5">
          {block.items.map((item) => (
            <li key={item.slice(0, 40)} className="text-base text-navy/75 leading-relaxed">{item}</li>
          ))}
        </ul>
      );
    case "table":
      return (
        <div className="mt-4 overflow-x-auto rounded-xl border border-border">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-navy text-white">
                {block.headers.map((h) => (
                  <th key={h} className="text-left px-4 py-3 font-bold align-top">{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {block.rows.map((row, i) => (
                <tr key={i} className={i % 2 ? "bg-background" : "bg-white"}>
                  {row.map((cell, j) => (
                    <td key={j} className="px-4 py-3 text-navy/75 align-top leading-relaxed">{cell}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      );
    default:
      return null;
  }
}

export default function DocRenderer({ meta, sections, testId }) {
  return (
    <article data-testid={testId} className="bg-white rounded-2xl border border-border p-8 lg:p-12">
      <header className="border-b border-border pb-8">
        <h1 className="text-3xl font-extrabold tracking-tight text-navy">{meta.title}</h1>
        <p className="mt-2 text-sm text-navy/60">{meta.subtitle}</p>
        <p className="mt-1 text-xs text-navy/40">{meta.updated}</p>
      </header>
      {sections.map((section) => (
        <section key={section.id} className="mt-10">
          <h2 className="text-2xl font-bold tracking-tight text-navy">{section.title}</h2>
          {section.blocks.map((block, i) => (
            <DocBlock key={i} block={block} />
          ))}
        </section>
      ))}
    </article>
  );
}
